  export const sortData = (data, sortConfig) => {
    
    const { key, direction } = sortConfig;
    if (!key) return data;
    return [...data].sort((a, b) => {
      let aValue = a[key];
      let bValue = b[key];

      if (['registration', 'fillProfile', 'emailConfirmed', 'posted', 'sms4Plus35', 
           'online', 'sales', 'ftd', 'turnover', 'investment'].includes(key)) {
        aValue = parseFloat(aValue) || 0;
        bValue = parseFloat(bValue) || 0;
      }

      if (aValue < bValue) {
        return direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  };